import React from 'react';
import MUTypography from '../../../../../ui/MUTypography';
import {
  ScopeTable
} from './index';
import EnvironmentTable from './Tables/EnvironmentTable';


const Info2 = (props) => (
  <div>
    <MUTypography variant="h4" className={props.classes.h4}>
      AUTHORIZATION
    </MUTypography>

    <MUTypography variant="display1" className={props.classes.paragraph} paragraph>
      To ensure secure and authorized access to our APIs, you must first go through the authorization process. Authorization is the process of allowing users or applications access to specific resources. As part of this process, obtaining a special authorization document called a "token" is required to access our APIs.
      <br /><br />
      The token is used to authenticate requests to our APIs and ensure their security. It provides developers with limited access to specific permissions and keeps control over their ability to access sensitive data. The token acquisition process typically occurs through an authentication server, allowing the developer to obtain an application-specific "access token."
      <br /><br />
      We employ the OAuth2 protocol to authorize Albaraka APIs. APIs are treated as either Public or Private based on authorization types. For Public APIs that do not contain customer data, the "Client Credentials Flow" method can be used. For private APIs requiring customer login, “Password Flow”, “Authorization Code Flow” or “Authorization Id Flow” (only used for Baas services) can be employed for access.
      <br /><br />
      In this section, you will find a detailed roadmap for various authorization types that will help you securely and effectively access our APIs. You can obtain detailed information under the headings Password Flow, Authorization Code Flow, Client Credentials Flow, and Authorization Id Flow.
    </MUTypography>

    <MUTypography variant="h5" className={props.classes.h5}>
      General Information You Need During the Authorization Stage in the Test Environment:
    </MUTypography>

    <EnvironmentTable />


    <MUTypography variant="h5" className={props.classes.h5}>
      Scopes
    </MUTypography>

    <MUTypography variant="display1" className={props.classes.paragraph} paragraph>
      Scopes are groups that consist of similar authorization, functionality, and usage areas of APIs. We use the scope as a parameter in the authorization step, and when we get authorization for a specific scope, we also get authorization for all APIs under that scope.
      <br /><br />
      Please verify which scopes were activated during the application creation process. Ensure that your selection is made from the activated scopes.
      <br /><br />
      When you create an application, you can specify which services you want to grant access to. Below, you can find the scopes, their definitions, and grant types associated with Albaraka APIs. Grant type is a parameter in the OAuth 2.0 protocol indicating the type of authorization requested by a client.
    </MUTypography>

    <ScopeTable />

    <MUTypography variant="display1" className={props.classes.paragraph}>
      You can find more detailed information on token acquisition methods under the main heading <strong>'Authorization'</strong> in the following subheadings:
      <br />
      <strong>Client Credentials Flow</strong>, <strong>Password Flow</strong>, <strong>Authorization Code Flow</strong> and <strong>Authorization Id Flow</strong>.
    </MUTypography>
  </div>
);

export default Info2;
